import type { IconData } from '@stacksjs/iconify-core'

export const natureUmbrella: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 8a8 8 0 1 1 16 0h-6v4a4 4 0 0 1-8 0h4V8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureUmbrella
